// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';



const { DataItem, User, Report, AnalyticsData, ActivityLog, SafetyForm } = initSchema(schema);

export {
  DataItem,
  User,
  Report,
  AnalyticsData,
  ActivityLog,
  SafetyForm
};